export function getCSSThemeClassName (css, theme: string, {prefix = '', suffix = ''}) {
  return css[`${prefix}${theme}${suffix}`]
}